import React from "react";
import { Text, Container, Stack, Link, Flex } from "basis";
import { Icon } from "../../components";
import {
  GATEWAY_ICON,
  MERCHANT_SUPPORT_EMAIL_ADDRESS,
} from "../../core/constants";

const InfoCard = ({
  title,
  description,
  addtDescription,
  children,
  gatewayName,
}) => {
  const heading = (
    <Stack gap="4">
      <Text textStyle="heading1">{title}</Text>
      <Text>{description}</Text>
      {addtDescription && <Text>{addtDescription}</Text>}
      <Stack direction="horizontal" align="left" gap="0 10">
        <Icon type="shopify" />

        <Text textStyle="heading3">+</Text>

        <Flex height="100%" placeItems="center right">
          <Icon type={GATEWAY_ICON[gatewayName] || "latitude"} size="172px" />
        </Flex>
      </Stack>
    </Stack>
  );

  const content = <Container margin="8 0">{children}</Container>;

  return (
    <Stack gap="2">
      {heading}
      {content}
    </Stack>
  );
};

export default InfoCard;
